import qs from 'query-string';
import ApiClientInstance, { ApiClient as ApiClientClass } from './ApiClient';
import api from './api';
import localStorageManager from '../utils/localStorageManager';
import { login } from '../utils/authRedirect';
import {
  cleanSessions, isSessionExpired, readSession, removeSession,
} from './authSession';

const LOCAL_STORAGE_TOKEN_NAME = 'access_token';
const FALLBACK_PATH = '/';

const getToken = () => localStorageManager.getItem(LOCAL_STORAGE_TOKEN_NAME);

const applyToken = (token) => {
  api.publicApi.auth = `Bearer ${token.access_token}`;
  ApiClientClass.token = token.access_token;
};

export const checkAuth = async () => {
  cleanSessions();
  const token = getToken();
  if (token) {
    applyToken(token);
    return { token };
  }
  login('Accountants workstation');

  return false;
};

export const completeAuth = async () => {
  const { code, state } = qs.parse(window.location.search);
  const session = readSession(state);
  removeSession(state);

  // A state we did not mint belongs to someone else's login, so the code must not be exchanged.
  if (!session || !code) {
    return { entryPath: FALLBACK_PATH };
  }

  const { entryPath } = session;
  try {
    const token = await ApiClientInstance.fetchTokenWithCode(code);
    localStorageManager.setItem(LOCAL_STORAGE_TOKEN_NAME, token.access_token, token.expires_in);
    applyToken(token);
    return { entryPath };
  } catch (e) {
    console.error(e);
    // Retry only an aged-out session: bouncing any other failure back to a guarded path loops.
    if (isSessionExpired(session)) {
      login('Accountants workstation', entryPath);
      return null;
    }
    return { entryPath: FALLBACK_PATH };
  }
};

ApiClientClass.onUnauthorized = () => login('Accountants workstation');
